<template>
    <div class="col-12 row p-4 px-2 m-0 justify-content-around">
        <div class="col-12 card card-outline card-primary p-2">
            <div class="card-header">
                <h3 class="h3">{{ t("admin.users") }}</h3>
            </div>
            <div v-if="fetching">Carregando dados...</div>
            <div class="card-body table-responsive" id="my-table">
                <button
                    class="btn btn-success btn-lg"
                    @click="() => (showNewUser = true)"
                >
                    Cadastrar usuário
                </button>
                <data-table
                    v-if="users"
                    class="table table-striped table-bordered"
                    :data="users"
                    :columns="columns"
                    :options="{
                        responsive: true,
                        autoWidth: false,
                        language: {
                            search: t('datatable.search'),
                            zeroRecords: t('datatable.zero'),
                            info: t('datatable.info'),
                            infoFiltered: t('datatable.filter'),
                            paginate: {
                                first: t('datatable.first'),
                                last: t('datatable.last'),
                                next: t('datatable.next'),
                                previous: t('datatable.previous'),
                            },
                        },
                        dom: `<'pb-2'B><'row'<'col-sm-6'l><'col-sm-6'f>><tr><'row'<'col-sm-6'i><'col-sm-6'p>>`,
                    }"
                >
                    <thead>
                        <tr class="table-primary">
                            <th>#</th>
                            <th>{{ t("auth.login.email") }}</th>
                            <th>{{ t("auth.signup.name") }}</th>
                            <th>{{ t("general.level") }}</th>
                            <th>{{ t("auth.signup.phone") }}</th>
                            <th>{{ t("profile.status") }}</th>
                            <th>{{ t("profile.end") }}</th>
                            <th>{{ t("general.actions") }}</th>
                        </tr>
                    </thead>
                </data-table>
            </div>
        </div>

        <!-- Modals do user -->
        <ModalComponent
            :classList="['col-10', 'col-md-7', 'col-lg-6', 'col-xlg-5']"
            v-if="selected"
            :title="selected.name"
            @hide="
                () => {
                    this.selected = null;
                }
            "
            :show="true"
        >
            <form ref="form" @submit.prevent="update" class="row p-1 col-12">
                <div
                    class="p-1 form-group m-0 py-2 col-12"
                    v-for="input in inputs"
                    :key="input.model"
                >
                    <label class="m-0" :for="input.model">{{
                        input.text
                    }}</label>
                    <input
                        type="date"
                        :name="input.model"
                        v-model="selected.subscription[input.model]"
                        class="form-control"
                    />
                </div>

                <div class="p-1 form-group m-0 py-2 col-12">
                    <span class="m-0" for="ai_credits"
                        >{{ t("ai.credits") }}: R$
                        {{
                            Number(selected.ai_credits)
                                .toFixed(2)
                                .replace(".", ",")
                        }}</span
                    >
                    <br />
                    <label class="m-0" for="ai_credits">{{
                        t("ai.add")
                    }}</label>
                    <input
                        type="number"
                        step="0.01"
                        name="ai_credits"
                        v-model="credits"
                        class="form-control"
                    />
                </div>

                <div class="p-1 form-group m-0 py-2 col-12">
                    <label class="m-0" for="password">{{
                        t("auth.changePass.title")
                    }}</label>
                    <input
                        type="password"
                        name="password"
                        v-model="selected.subscription.password"
                        class="form-control"
                    />
                </div>

                <div class="text-right">
                    <button class="btn btn-primary mx-1">
                        {{ t("treinos.update") }}
                    </button>
                    <button
                        v-if="!selected.premiun_gifs_pack"
                        type="button"
                        @click.prevent="() => setPremiumGif(selected.id)"
                        class="btn btn-warning mx-1"
                    >
                        Atribuir pacote de gifs premium
                    </button>
                    <button
                        v-else
                        type="button"
                        @click.prevent="() => setPremiumGif(selected.id, true)"
                        class="btn btn-danger mx-1"
                    >
                        Remover pacote de gifs premium
                    </button>
                </div>
            </form>
        </ModalComponent>
        <!-- ./Modals do user -->

        <!-- Modals do user -->
        <ModalComponent
            :classList="['col-10', 'col-md-6', 'col-lg-5', 'pa-4']"
            v-if="showNewUser"
            title="Novo usuario"
            @hide="
                () => {
                    this.showNewUser = false;
                }
            "
            :show="true"
        >
            <form @submit.prevent="createUser">
                <label>Nome do usuario</label>
                <div class="input-group mb-3">
                    <input
                        type="text"
                        required
                        class="form-control"
                        placeholder="Nome"
                        v-model="newUser.name"
                    />
                    <div class="input-group-append">
                        <div class="input-group-text">
                            <span class="fas fa-user"></span>
                        </div>
                    </div>
                </div>

                <label>Email</label>
                <div class="input-group mb-3">
                    <input
                        type="email"
                        required
                        class="form-control"
                        placeholder="Email"
                        v-model="newUser.email"
                    />
                    <div class="input-group-append">
                        <div class="input-group-text">
                            <span class="fas fa-envelope"></span>
                        </div>
                    </div>
                </div>

                <label>Telephone</label>
                <div class="input-group mb-3">
                    <input
                        type="text"
                        required
                        class="form-control"
                        placeholder="telefone"
                        v-model="newUser.phone"
                    />
                    <div class="input-group-append">
                        <div class="input-group-text">
                            <span class="fas fa-phone"></span>
                        </div>
                    </div>
                </div>

                <label>Senha</label>
                <div class="input-group mb-3">
                    <input
                        type="password"
                        required
                        class="form-control"
                        :placeholder="t('auth.changePass.newpass')"
                        v-model="newUser.password"
                    />
                    <div class="input-group-append">
                        <div class="input-group-text">
                            <span class="fas fa-lock"></span>
                        </div>
                    </div>
                </div>

                <div class="row justify-content-end">
                    <div class="col-12 col-md-4">
                        <button class="btn btn-primary btn-block">
                            Adicionar
                        </button>
                    </div>
                </div>
            </form>
        </ModalComponent>
        <!-- ./Modals do user -->

        <!-- Modal de Limite de Gif -->
        <ModalComponent
            :classList="['col-10', 'col-md-6', 'col-lg-5', 'pa-4']"
            v-if="showGifsLimit"
            title="Limites de gifs do usuario"
            @hide="
                () => {
                    this.showGifsLimit = false;
                }
            "
            :show="true"
        >
            <GifsLimitComponent :userId="Number(showGifsLimit)" />
        </ModalComponent>
        <!-- ./Modal de Limite de Gif -->
    </div>
</template>

<script>
import DataTable from "datatables.net-vue3";
import DataTableLib from "datatables.net-bs5";
import "datatables.net-buttons-bs5";
import ModalComponent from "@/components/AdminLTE/Components/ModalComponent.vue";
import GifsLimitComponent from "@/components/GifsLimitComponent.vue";
import { mapMutations, mapState, mapActions } from "vuex";
import { t } from "@/lang";
DataTable.use(DataTableLib);

export default {
    name: "FormacoesView",
    components: {
        DataTable,
        GifsLimitComponent,
        ModalComponent,
    },
    data() {
        return {
            users: null,
            user: null,
            showGifsLimit: false,
            showNewUser: false,
            newUser: {
                phone: "",
                email: "",
                name: "",
                password: "",
            },
            selected: null,
            credits: 0,
            fetching: false,
            access_key: null,
            password: null,
            columns: [
                { data: "id" },
                { data: "email" },
                { data: "name" },
                { data: "level" },
                { data: "phone" },
                {
                    data: null,
                    render: (data) => `
                        ${
                            data.subscription_active
                                ? "<label class='text-success'>" +
                                  t("profile.active") +
                                  "</label>"
                                : "<label class='text-danger'>" +
                                  t("profile.inactive") +
                                  "</label>"
                        }
                    `,
                },
                {
                    data: null,
                    render: (data) => `
                        ${
                            data.subscription
                                ? data.subscription.end_subscription
                                : "----"
                        }    
                    `,
                },
                {
                    data: null,
                    render: (data) => `
                        <span class='p-1'>
                            <button class='btn btn-warning btn-flat' data-id='${data.id}' data-action='edit'>
                                <i class='fa fa-edit' data-id='${data.id}' data-action='edit'></i>
                            </button>
                        </span>
                        <span class='p-1' title='Limite de Gifs'>
                            <button class='btn btn-warning btn-flat' data-id='${data.id}' data-action='showGifLimit'>
                                <i class='fa fa-images' data-id='${data.id}' data-action='showGifLimit'></i>
                            </button>
                        </span>
                        <span class='p-1' ${data.level == "admin" || (data.level == "mod" && this.user.level == "admin") ? "style='display: none;'" : ""}>
                            <button class='btn btn-success btn-flat' data-id='${data.id}' data-action='up'>
                                <i class='fa fa-arrow-up' data-id='${data.id}' data-action='up'></i>
                            </button>
                        </span>
                        <span class='p-1' ${data.level == "user" ? "style='display: none;'" : ""}>
                            <button class='btn btn-danger btn-flat' data-id='${data.id}' data-action='down'>
                                <i class='fa fa-arrow-down' data-id='${data.id}' data-action='down'></i>
                            </button>
                        </span>
                        <span class='p-1'>
                            <button class='btn btn-danger btn-flat' data-id='${data.id}' data-action='delete'>
                                <i class='fa fa-trash' data-id='${data.id}' data-action='delete'></i>
                            </button>
                        </span>
                    `,
                },
            ],
            inputs: [
                {
                    model: "end_subscription",
                    text: t("admin.end_subscription"),
                },
                { model: "last_payment", text: t("admin.last_payment") },
            ],
        };
    },
    async created() {
        this.SET_LOADING(true);
        document.title = t("admin.users");
        (this.getUser(), this.getUsers());
        this.SET_LOADING(false);
    },

    computed: {
        ...mapState(["loading"]),
    },
    methods: {
        ...mapActions(["get", "post", "put", "delete"]),
        ...mapMutations(["SET_USER", "SET_LOADING"]),
        async handleClick(event) {
            if (event.target.hasAttribute("data-action")) {
                const userId = event.target.getAttribute("data-id");
                let user = null;
                switch (event.target.getAttribute("data-action")) {
                    case "edit":
                        user = this.users.filter(
                            (user) => user.id == userId,
                        )[0];
                        this.selected = Object.assign({}, user);

                        if (!this.selected.subscription) {
                            this.selected.subscription = {};
                        }
                        break;
                    case "up":
                        this.selected = null;
                        if (confirm(t("general.do-you-want"))) {
                            await this.update(userId);
                        }
                        break;
                    case "down":
                        this.selected = null;
                        if (confirm(t("general.do-you-want"))) {
                            await this.update(userId, true);
                        }
                        break;
                    case "delete":
                        this.selected = null;
                        if (confirm(t("general.do-you-want"))) {
                            await this.deleteUser(userId);
                        }
                        break;
                    case "showGifLimit":
                        this.showGifsLimit = userId;
                        break;
                }
            }
        },
        async getUsers() {
            this.fetching = true;
            const response = await this.get({ url: "admin/users" });
            this.users = response.data.users;

            if (response.status != 200) {
                alert(response.data.message);
                location = "/profile";
            }

            this.fetching = false;
            if (!this.loading) {
                this.$el
                    .querySelector("#my-table")
                    .addEventListener("click", this.handleClick);
            }
        },
        async update(id = null, down = false) {
            this.SET_LOADING(true);
            const base = {};
            if (this.credits != 0) {
                base.ai_credits = this.credits;
            }
            const response = await this.put({
                url: "admin/user/" + (this.selected ? this.selected.id : id),
                data: Object.assign(
                    this.selected ? this.selected.subscription : {},
                    { down: down, level: true },
                    base,
                ),
            });

            if (response.status == 200) {
                this.selected.ai_credits += this.credits;
                alert(t("exercices.save-success"));
            } else {
                alert(response.data.status);
                console.log(response);
            }
            this.selected = null;
            this.credits = 0;
            this.SET_LOADING(false);
            this.getUsers();
        },
        async setPremiumGif(id, remove = false) {
            if (confirm(t("general.do-you-want"))) {
                this.SET_LOADING(true);

                const response = await this.post({
                    url:
                        `admin/user/premiun_gifs/${id}` +
                        (remove ? "?remove=true" : ""),
                });

                if (response.status == 200) {
                    this.selected.premiun_gifs_pack =
                        response.data.user.premiun_gifs_pack;
                    const user = this.users.find((user) => user.id == id);
                    console.log(user);
                    if (user) {
                        user.premiun_gifs_pack =
                            response.data.user.premiun_gifs_pack;
                    }
                    alert(t("exercices.save-success"));
                } else {
                    alert(response.data.status);
                }
                console.log(response);
                this.selected = null;
                this.SET_LOADING(false);
            }
        },
        async deleteUser(id) {
            this.SET_LOADING(true);
            const response = await this.delete({
                url: "user?id=" + id,
            });

            if (response.status == 200) {
                alert(t("general.deleted"));
            } else {
                alert(response.data.status);
                console.log(response);
            }
            this.selected = null;
            this.SET_LOADING(false);
            this.getUsers();
        },
        async getUser() {
            const response = await this.get({ url: "user" });
            if (response.status == 200) {
                this.user = response.data.user;
            } else {
                alert(response.data.message);
            }
        },
        async createUser() {
            this.SET_LOADING(true);
            try {
                const res = await this.post({
                    url: "admin/user",
                    data: { ...this.newUser },
                });
                if (res.status != 200) {
                    if (res.data?.message) {
                        alert(res.data.message);
                    }
                    this.SET_LOADING(false);
                } else {
                    this.showNewUser = false;
                    alert("Usuario cadastrado com sucesso");
                    await this.getUsers();
                }
                console.log(res);
            } catch (e) {
                console.log(e);
                alert("Ocorreum um erro");
                if (e.data?.message) {
                    alert(e.data.message);
                }
                this.SET_LOADING(false);
            }
            this.SET_LOADING(false);
        },
        t,
    },
};
</script>

<style lang="scss" scoped>
@import "datatables.net-bs5";
.upload-btn {
    bottom: 0px;
    right: 0px;
}
</style>
